import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import App from "@/App";
import { ClientAccessScreen, isAccessPage } from "@/screens/ClientAccessScreen";
import { initTelegram } from "@/boot/telegram";
import { ToastProvider } from "@/components/ui/Toast";
import { initTheme } from "@/theme/theme";
import "@/styles/globals.css";

// Order matters: hand Telegram its ready()/expand() first, then project its
// themeParams onto the CSS tokens everything else renders against (spec §1).
initTelegram();
initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        {/* Spec 054, step 3b: the safe link's page is the client's — no login, no tasker. */}
        {isAccessPage(window.location.pathname) ? (
          <ClientAccessScreen />
        ) : (
          <BrowserRouter>
            <App />
          </BrowserRouter>
        )}
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
